export function scrollToFirstInvalidField(root = document) {
  const group = root.querySelector(".ui-form-group--error");
  if (!group) {
    return null;
  }

  group.scrollIntoView({ behavior: "smooth", block: "center" });
  group.querySelector("input, textarea, select")?.focus({ preventScroll: true });

  return group;
}
